import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';

export const useFindPsychiatristPageStyles = makeStyles()(theme => ({
  header: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up('sm')]: {
      padding: 0,
    }
  },
  root: {
    background: grey[50],
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      background: theme.palette.common.white,
      padding: theme.spacing(13, 0, 12),
      width: '690px',
    },
  }
}));
